(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    const storageKey = 'adriana:favourite-products';

  const readFavourites = () => {
    try {
      return JSON.parse(localStorage.getItem(storageKey) || '[]');
    } catch {
      return [];
    }
  };

  const updateFavouriteButton = (button, favourites) => {
    const active = favourites.includes(button.dataset.productHandle);
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', String(active));
    button.setAttribute('aria-label', active ? button.dataset.removeLabel : button.dataset.addLabel);
  };

  const initialiseFavouriteButtons = () => {
    const favourites = readFavourites();
    document.querySelectorAll('.product-favourite-button').forEach((button) => {
      updateFavouriteButton(button, favourites);
      if (button.dataset.favouriteReady === 'true') return;
      button.dataset.favouriteReady = 'true';
      button.addEventListener('click', () => {
        const saved = readFavourites();
        const handle = button.dataset.productHandle;
        const next = saved.includes(handle) ? saved.filter((item) => item !== handle) : [...saved, handle];
        try {
          localStorage.setItem(storageKey, JSON.stringify(next));
        } catch {
          return;
        }
        document.querySelectorAll(`.product-favourite-button[data-product-handle="${CSS.escape(handle)}"]`).forEach((item) => {
          updateFavouriteButton(item, next);
        });
      });
    });
  };

  const organiseProductDescription = () => {
    if (window.location.pathname === '/products/premium-executive-comfortable-shrug-set-pcs-09') {
      document.querySelectorAll('.product-information .details-content .rte').forEach((description) => {
        const text = description.textContent.replace(/\s+/g, ' ').trim();
        if (!text.includes('Premium shrug set') || (!text.includes('CY Jacquard') && !description.dataset.pcs09Formatted)) return;

        description.dataset.pcs09Formatted = 'true';
        description.innerHTML = `
          <h3>Product Description</h3>
          <ul>
            <li>Premium shrug set – Executive Series.</li>
            <li>Fabric: CY Jacquard cotton blend shrug.</li>
            <li>Inner co-ords: CY cotton blend.</li>
            <li>Sizes: 36–50.</li>
            <li>Shrug length: 45&quot;.</li>
            <li>Inner length: 40&quot;.</li>
            <li>Shrug sleeve: 22&quot;.</li>
            <li>Inner: Sleeveless.</li>
            <li>Pants length: 38&quot; for sizes 36–38; 40&quot; for sizes 40–50.</li>
          </ul>
          <h3>Benefits</h3>
          <ul></ul>
          <p>Size Guide:Adriana Women kurti Size chart</p>
          <p>Care Instructions</p>
        `;
      });
    }

    if (window.location.pathname === '/products/luxury-mauve-silk-shrug-set-with-embroidered-cutwork-lsc-07') {
      document.querySelectorAll('.product-information .details-content .rte').forEach((description) => {
        const text = description.textContent.replace(/\s+/g, ' ').trim();
        if (!text.includes('premium shrug set') || (!text.includes('Black velvet floral embroidery') && !description.dataset.lsc08Formatted)) return;

        description.dataset.lsc08Formatted = 'true';
        description.innerHTML = `
          <h3>Product Description</h3>
          <ul>
            <li>Premium shrug set – Luxury Series.</li>
            <li>Black velvet floral embroidery with fine detailing.</li>
            <li>Premium self-textured silk shrug and pants.</li>
            <li>Inner: CY cotton blend.</li>
            <li>Shrug length: 45&quot;.</li>
            <li>Inner length: 40&quot;.</li>
            <li>Shrug sleeve: 22&quot;.</li>
            <li>Inner: Sleeveless.</li>
            <li>Pants length: 38&quot; for sizes 36–38; 40&quot; for sizes 40–50.</li>
          </ul>
          <p>Size Guide:Adriana Women kurti Size chart</p>
          <p>Care Instructions</p>
        `;
      });
    }

    if (window.location.pathname === '/products/comfortable-kimono-shurag-code-cs-92') {
      document.querySelectorAll('.product-information .details-content .rte').forEach((description) => {
        const legacyHeading = [...description.querySelectorAll('p')].find(
          (paragraph) => paragraph.textContent.replace(/\s+/g, ' ').trim() === 'Product Description'
        );
        if (!legacyHeading) return;

        const heading = document.createElement('h3');
        heading.textContent = 'Product Description';
        legacyHeading.replaceWith(heading);
      });
    }

    const standardKimonoDescriptionHandles = [
      '/products/comfortable-kimono-shurag-code-cs-111',
      '/products/comfortable-kimono-shurag-code-cs-109',
      '/products/comfortable-kimono-shurag-code-cs-105',
      '/products/comfortable-kimono-shurag-code-cs-89',
      '/products/comfortable-kimono-shurag-code-cs-102',
      '/products/comfortable-kimono-shurag-code-cs-83',
      '/products/comfortable-kimono-shurag-code-cs-65',
      '/products/comfortable-kimono-shurag-code-cs-96',
      '/products/comfortable-kimono-shurag-code-cs-66',
      '/products/comfortable-kimono-shurag-code-cs-69',
      '/products/comfortable-kimono-shurag-code-cs-101'
    ];

    if (standardKimonoDescriptionHandles.includes(window.location.pathname)) {
      document.querySelectorAll('.product-information .details-content .rte').forEach((description) => {
        if (!description.textContent.includes('Product Description')) return;
        description.innerHTML = `
          <h3>Product Description</h3>
          <ul>
            <li>Semi-Long Kimono Shrug</li>
            <li>Material: Premium Alisha Georgette</li>
            <li>Length: 45 inches</li>
            <li>Sleeve Length: 22 inches (Full Sleeve)</li>
            <li>Fit: Comfortable, modest &amp; easy to style</li>
          </ul>
          <p>Size Guide:Adriana Women kurti Size chart</p>
          <p>Care Instructions</p>
        `;
      });
    }

    const preservedShrugDescriptionHandles = [
      '/products/comfortable-shurag-code-cs-03',
      '/products/comfortable-layers-shurag-code-cs-45',
      '/products/comfortable-layers-shurag-code-cs-46'
    ];

    if (preservedShrugDescriptionHandles.includes(window.location.pathname)) {
      document.querySelectorAll('.product-information .details-content .rte').forEach((description) => {
        if (!description.textContent.includes('Product Description')) return;
        description.innerHTML = `
          <h3>Product Description</h3>
          <ul>
            <li>Semi-Long Shrug</li>
            <li>Material: Premium Alisha and cherry Georgette</li>
            <li>Available Sizes: 38, 40, 42, 44, 46, 48, 50</li>
            <li>Length: 48 inches</li>
            <li>Sleeve Length: 22 inches (Full Sleeve)</li>
            <li>Style: Semi-Long Kimono Shrug</li>
            <li>Fit: Comfortable, modest &amp; easy to style</li>
          </ul>
          <p>Size Guide:Adriana Women kurti Size chart</p>
          <p>Care Instructions</p>
        `;
      });
    }

    const classicShrugDescriptionHandles = [
      '/products/comfortable-anarkoli-shurag-code-cs-43',
      '/products/comfortable-kurti-fusion-shurag-code-cs-49',
      '/products/comfortable-kurti-covers-shurag-code-cs-41',
      '/products/comfortable-kurti-covers-shurag-code-cs-40'
    ];

    if (classicShrugDescriptionHandles.includes(window.location.pathname)) {
      document.querySelectorAll('.product-information .details-content .rte').forEach((description) => {
        if (!description.textContent.includes('Product Description')) return;
        description.innerHTML = `
          <h3>Product Description</h3>
          <ul>
            <li>Semi-Long Shrug</li>
            <li>Material: Premium Alisha Georgette</li>
            <li>Available Sizes: 38, 40, 42, 44, 46, 48, 50</li>
            <li>Length: 48 inches</li>
            <li>Sleeve Length: 22 inches (Full Sleeve)</li>
            <li>Style: Semi-Long Kimono Shrug</li>
            <li>Fit: Comfortable, modest &amp; easy to style</li>
          </ul>
          <p>Size Guide:Adriana Women kurti Size chart</p>
          <p>Care Instructions</p>
        `;
      });
    }

    if (window.location.pathname === '/products/comfortable-kimono-shurag-full-set-code-cs-113') {
      document.querySelectorAll('.product-information .details-content .rte').forEach((description) => {
        const productHeading = [...description.querySelectorAll('h3')].find(
          (heading) => heading.textContent.trim() === 'Product Description'
        );
        if (!productHeading) return;

        if (!description.textContent.includes('Size Guide:Adriana Women kurti Size chart')) {
          const sizeGuide = document.createElement('p');
          sizeGuide.textContent = 'Size Guide:Adriana Women kurti Size chart';
          description.appendChild(sizeGuide);
        }
        if (![...description.querySelectorAll('p')].some((paragraph) => paragraph.textContent.trim() === 'Care Instructions')) {
          const careInstructions = document.createElement('p');
          careInstructions.textContent = 'Care Instructions';
          description.appendChild(careInstructions);
        }
      });
    }

    if (window.location.pathname === '/products/comfortable-kimono-shurag-full-set-code-cs-114') {
      document.querySelectorAll('.product-information .details-content .rte').forEach((description) => {
        if (!description.textContent.includes('Product Description')) return;
        description.innerHTML = `
          <h3>Product Description</h3>
          <ul>
            <li>Semi Long sharug.</li>
            <li>Fabrics: Premium Imported Printed Alisha Gorgette.</li>
            <li>Size: 36–50.</li>
            <li>Length: 45&quot;.</li>
            <li>Sleeve: 22&quot;.</li>
            <li>Inner: CY fabric; sizes 36–50 according to shrug size; length 38&quot;.</li>
            <li>Pant: CY fabric; length 38&quot; for sizes 36–38 and 40&quot; for sizes 40–50.</li>
          </ul>
          <p>Size Guide:Adriana Women kurti Size chart</p>
          <p>Care Instructions</p>
        `;
      });
    }

    if (window.location.pathname === '/products/comfortable-kimono-shurag-full-set-code-cs-112') {
      document.querySelectorAll('.product-information .details-content .rte').forEach((description) => {
        const productHeading = [...description.querySelectorAll('h3')].find(
          (heading) => heading.textContent.trim() === 'Product Description'
        );
        const descriptionList = productHeading?.nextElementSibling;
        if (!descriptionList?.matches('ul, ol')) return;
        description.querySelectorAll('p').forEach((paragraph) => {
          const text = paragraph.textContent.replace(/\s+/g, ' ').trim();
          let bulletText = '';
          if (/^Inner\s*-/i.test(text)) {
            bulletText = 'Inner: CY fabric; sizes 36–50 according to shrug size; length 38&quot;.';
          } else if (/^pant\s*-/i.test(text)) {
            bulletText = 'Pant: Premium Imported Printed Alisha Gorgette; length 38&quot; for sizes 36–38 and 40&quot; for sizes 40–50.';
          }
          if (!bulletText) return;

          const item = document.createElement('li');
          item.innerHTML = bulletText;
          descriptionList.appendChild(item);
          paragraph.remove();
        });

        const legacyBenefitsLabel = [...description.querySelectorAll('p, h3')].find(
          (element) => /^benifit$/i.test(element.textContent.replace(/\s+/g, ' ').trim())
        );
        if (legacyBenefitsLabel) {
          const legacyBenefitsList = legacyBenefitsLabel.nextElementSibling;
          if (legacyBenefitsList?.matches('ul, ol')) legacyBenefitsList.remove();
          legacyBenefitsLabel.remove();
        }
      });
    }

    if (window.location.pathname === '/products/comfortable-kimono-shurag-full-set-code-cs-115') {
      document.querySelectorAll('.product-information .details-content .rte').forEach((description) => {
        const productHeading = [...description.querySelectorAll('h3')].find(
          (heading) => heading.textContent.trim() === 'Product Description'
        );
        const descriptionList = productHeading?.nextElementSibling;
        if (!descriptionList?.matches('ul, ol')) return;

        const legacyBenefitsLabel = [...description.querySelectorAll('p, h3')].find(
          (element) => /^benifit$/i.test(element.textContent.replace(/\s+/g, ' ').trim())
        );

        let sibling = descriptionList.nextElementSibling;
        while (sibling && sibling !== legacyBenefitsLabel) {
          const nextSibling = sibling.nextElementSibling;
          if (sibling.matches('p')) {
            const text = sibling.textContent.replace(/\s+/g, ' ').trim();
            if (text) {
              const item = document.createElement('li');
              item.textContent = text;
              descriptionList.appendChild(item);
            }
            sibling.remove();
          }
          sibling = nextSibling;
        }

        if (legacyBenefitsLabel) {
          const legacyBenefitsList = legacyBenefitsLabel.nextElementSibling;
          if (legacyBenefitsList?.matches('ul, ol')) legacyBenefitsList.remove();
          legacyBenefitsLabel.remove();
        }
      });
    }

    document.querySelectorAll('.product-information .details-content .rte p').forEach((paragraph) => {
      const text = paragraph.textContent.replace(/\u00a0/g, ' ').trim();
      const normalizedText = text.replace(/\s+/g, ' ').toLowerCase();
      const hasContent = paragraph.querySelector('img, video, iframe, table, button, input, svg');
      const isLegacyColorNotice =
        normalizedText.includes('slight color variations') &&
        normalizedText.includes('lighting') &&
        normalizedText.includes('device differences');

      if ((!text && !hasContent) || isLegacyColorNotice) paragraph.remove();
    });

    document.querySelectorAll('.product-information .details-content .rte h3').forEach((heading) => {
      const label = heading.textContent.replace(/\u00a0/g, ' ').trim();

      if (label === 'Product Description') {
        heading.textContent = label;
        const descriptionList = heading.nextElementSibling;
        if (descriptionList?.matches('ul, ol')) descriptionList.classList.add('product-description-list');
      }
      if (label === 'Benifit') heading.textContent = 'Benefits';
    });

    document.querySelectorAll('.product-information .details-content .rte li').forEach((item) => {
      if (item.textContent.replace(/\s+/g, ' ').trim() === 'Size: 36-50.') item.remove();
    });

    document.querySelectorAll('.product-information .details-content .rte p').forEach((paragraph) => {
      const text = paragraph.textContent.replace(/\s+/g, ' ').trim();
      if (text.includes('Care Instructions')) {
        const wrapper = document.createElement('div');
        wrapper.className = 'product-care-instructions';
        wrapper.innerHTML = `
          <button class="product-care-instructions__trigger" type="button" aria-haspopup="dialog">
            <span>Care Instructions</span><span aria-hidden="true">›</span>
          </button>
          <dialog class="product-care-dialog" aria-labelledby="product-care-dialog-title">
            <div class="product-care-dialog__panel">
              <div class="product-care-dialog__header">
                <h2 id="product-care-dialog-title">Care Instructions</h2>
                <button class="product-care-dialog__close" type="button" aria-label="Close care instructions">×</button>
              </div>
              <ul>
                <li><strong>Gentle wash recommended</strong> — hand wash or use a delicate machine cycle.</li>
                <li><strong>Wash with similar colors</strong> and avoid bleach or harsh detergents.</li>
                <li><strong>Do not soak for extended periods</strong> to help preserve the fabric and color.</li>
                <li><strong>Air dry in the shade</strong> and avoid prolonged exposure to direct sunlight.</li>
                <li><strong>Iron on low to medium heat</strong>, preferably on the reverse side.</li>
                <li>For <strong>delicate, embroidered, embellished, or specialty fabrics</strong>, professional dry cleaning is recommended.</li>
              </ul>
            </div>
          </dialog>
        `;
        paragraph.replaceWith(wrapper);
        const productDetails = wrapper.closest('.product-details');
        const disclaimer = productDetails?.querySelector('.product-color-disclaimer');
        if (disclaimer) wrapper.after(disclaimer);
        const dialog = wrapper.querySelector('.product-care-dialog');
        wrapper.querySelector('.product-care-instructions__trigger').addEventListener('click', () => dialog.showModal());
        wrapper.querySelector('.product-care-dialog__close').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
        return;
      }
      if (text.includes('Size Guide:Adriana Women kurti Size chart')) {
        const chart = document.createElement('section');
        chart.className = 'product-size-chart';
        chart.setAttribute('aria-labelledby', 'adriana-size-chart-title');
        chart.innerHTML = `
          <h3 id="adriana-size-chart-title">Women’s Size Chart</h3>
          <p class="product-size-chart__unit">Measurements in inches</p>
          <div class="product-size-chart__scroll">
            <table>
              <thead><tr><th scope="col">Size</th><th scope="col">Waist</th><th scope="col">Hip</th><th scope="col">Shoulder</th></tr></thead>
              <tbody>
                <tr><th scope="row">36</th><td>33</td><td>39</td><td>13.5</td></tr>
                <tr><th scope="row">38</th><td>34</td><td>41</td><td>14.5</td></tr>
                <tr><th scope="row">40</th><td>36</td><td>42</td><td>15</td></tr>
                <tr><th scope="row">42</th><td>37</td><td>44</td><td>15.5</td></tr>
                <tr><th scope="row">44</th><td>39</td><td>46</td><td>16</td></tr>
                <tr><th scope="row">46</th><td>41</td><td>48</td><td>16.5</td></tr>
                <tr><th scope="row">48</th><td>43</td><td>50</td><td>16.5</td></tr>
                <tr><th scope="row">50</th><td>45</td><td>52</td><td>17</td></tr>
              </tbody>
            </table>
          </div>
          <p class="product-size-chart__note">Sleeve and length may vary by design. Measurements may vary by ±0.5 inch.</p>
        `;
        paragraph.replaceWith(chart);
        return;
      }
    });

    document.querySelectorAll('.product-information .details-content .rte p, .product-information .details-content .rte h3').forEach((priceLine) => {
      if (priceLine.classList.contains('product-price-chart')) return;
      const text = priceLine.textContent.replace(/\s+/g, ' ').trim();
      const prices = text.match(/Single\s+\S+\s+BDT[-:\s]*([\d,]+).*?Inner\s+Set\s+Co[\s-]*ords[-:\s]*BDT[-:\s]*([\d,]+).*?Full\s+Set\s+combo\s+BDT[-:\s]*([\d,]+)/i);
      if (!prices) return;

      const formatPrice = (price) => Number(price.replace(/,/g, '')).toLocaleString('en-US');
      const chart = document.createElement('div');
      chart.className = 'product-price-chart';
      chart.setAttribute('aria-label', 'Product package prices');
      chart.innerHTML = `
        <span class="product-price-chart__header"><strong>What you get</strong><strong>Price</strong></span>
        <span class="product-price-chart__row"><span>Shrug only</span><strong>Tk ${formatPrice(prices[1])}</strong></span>
        <span class="product-price-chart__row"><span>Inner co-ords set only</span><strong>Tk ${formatPrice(prices[2])}</strong></span>
        <span class="product-price-chart__row"><span>Complete combo<br><small>Shrug + Inner set</small></span><strong>Tk ${formatPrice(prices[3])}</strong></span>
        <small class="product-price-chart__note">Please note: Hijab is not included with any option.</small>
      `;
      priceLine.replaceWith(chart);
    });

    const cmcCareHandles = [
      '/products/comfotable-modest-cape-cmc-02',
      '/products/comfotable-modest-cape-cmc-03',
      '/products/comfotable-modest-cape-cmc-04',
      '/products/comfortable-modest-cape-cmc-05',
      '/products/comfortable-modest-cape-cmc-06',
      '/products/comfotable-khimer-collection-ckc-05',
    ];
    const isCmcCareProduct = cmcCareHandles.includes(window.location.pathname);
    const cmcPriceChartHandles = [
      '/products/comfotable-modest-cape-cmc-02',
      '/products/comfotable-modest-cape-cmc-03',
      '/products/comfotable-modest-cape-cmc-04',
      '/products/comfortable-modest-cape-cmc-05',
      '/products/comfortable-modest-cape-cmc-06',
    ];
    const isCmcPriceChartProduct = cmcPriceChartHandles.includes(window.location.pathname);

    document.querySelectorAll('.product-information .details-content .rte').forEach((description) => {
      const headings = [...description.querySelectorAll('h3')];
      const productHeading = headings.find((heading) => heading.textContent.trim() === 'Product Description');
      if (!productHeading) return;

      if (description.dataset.hideBenefits === 'true') {
        headings.filter((heading) => /^(benefits|benifit)$/i.test(heading.textContent.trim())).forEach((heading) => {
          const list = heading.nextElementSibling;
          if (list?.matches('ul, ol')) list.remove();
          heading.remove();
        });
        return;
      }

      let benefitsHeading = headings.find((heading) => /^(benefits|benifit)$/i.test(heading.textContent.trim()));
      if (!benefitsHeading) {
        benefitsHeading = document.createElement('h3');
        const anchor = description.querySelector('.product-size-chart, .product-care-instructions, .product-color-disclaimer');
        if (anchor) anchor.before(benefitsHeading);
        else description.appendChild(benefitsHeading);
      }

      benefitsHeading.textContent = 'Benefits';
      benefitsHeading.className = 'product-benefits-title';
      const existingList = benefitsHeading.nextElementSibling;
      if (existingList?.matches('ul, ol')) existingList.remove();

      const benefitsList = document.createElement('ul');
      benefitsList.className = 'product-benefits-list';
      benefitsList.innerHTML = `
        <li>Soft fabric.</li>
        <li>Elegant flow.</li>
        <li>Comfortable fitting.</li>
        <li>Premium finishing.</li>
      `;
      benefitsHeading.after(benefitsList);

      if (isCmcCareProduct) {
        let careInstructions = description.querySelector('.product-care-instructions');
        if (!careInstructions) {
          careInstructions = document.createElement('div');
          careInstructions.className = 'product-care-instructions';
          careInstructions.innerHTML = `
            <button class="product-care-instructions__trigger" type="button" aria-haspopup="dialog"><span>Care Instructions</span><span aria-hidden="true">›</span></button>
            <dialog class="product-care-dialog" aria-labelledby="cmc-care-dialog-title">
              <div class="product-care-dialog__panel">
                <div class="product-care-dialog__header"><h2 id="cmc-care-dialog-title">Care Instructions</h2><button class="product-care-dialog__close" type="button" aria-label="Close care instructions">×</button></div>
                <ul>
                  <li><strong>Gentle wash recommended</strong> — hand wash or use a delicate machine cycle.</li>
                  <li><strong>Wash with similar colors</strong> and avoid bleach or harsh detergents.</li>
                  <li><strong>Do not soak for extended periods</strong> to help preserve the fabric and color.</li>
                  <li><strong>Air dry in the shade</strong> and avoid prolonged exposure to direct sunlight.</li>
                  <li><strong>Iron on low to medium heat</strong>, preferably on the reverse side.</li>
                  <li>For <strong>delicate or embroidered fabrics</strong>, professional dry cleaning is recommended.</li>
                </ul>
              </div>
            </dialog>`;
          const dialog = careInstructions.querySelector('.product-care-dialog');
          careInstructions.querySelector('.product-care-instructions__trigger').addEventListener('click', () => dialog.showModal());
          careInstructions.querySelector('.product-care-dialog__close').addEventListener('click', () => dialog.close());
          dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
        }
        const disclaimer = document.querySelector('.product-details .product-color-disclaimer');
        benefitsList.after(careInstructions);
        if (disclaimer) careInstructions.after(disclaimer);
      }


      if (isCmcPriceChartProduct) {
        const productDetails = document.querySelector('.product-details');
        const capePrice = Number(productDetails?.dataset.productPrice || 0) / 100;
        const innerPrice = 1400;
        const comboPrice = capePrice + innerPrice;
        const formatPrice = (price) => price.toLocaleString('en-US');
        let priceChart = document.querySelector('.cmc-price-chart');
        if (!priceChart) {
          priceChart = document.createElement('section');
          priceChart.className = 'cmc-price-chart';
          priceChart.setAttribute('aria-label', 'Cape package prices');
        }
        priceChart.innerHTML = `
          <div class="cmc-price-chart__header"><strong>What you get</strong><strong>Price</strong></div>
          <div class="cmc-price-chart__row"><span>Cape only</span><strong>Tk ${formatPrice(capePrice)}</strong></div>
          <div class="cmc-price-chart__row"><span>Inner co-ords set only</span><strong>Tk ${formatPrice(innerPrice)}</strong></div>
          <div class="cmc-price-chart__row"><span>Complete combo<br><small>Cape + Inner set</small></span><strong>Tk ${formatPrice(comboPrice)}</strong></div>
          <small class="cmc-price-chart__note">Please note: Hijab is not included with any option.</small>
        `;
        benefitsHeading.before(priceChart);
      }
    });

    let careFallbackAdded = false;
    const descriptions = document.querySelectorAll('.product-information .details-content .rte');
    const careInstructionExists = Array.from(descriptions).some((description) => description.querySelector('.product-care-instructions'));
    if (!careInstructionExists && descriptions.length > 0) {
      const description = descriptions[0];
      const carePlaceholder = document.createElement('p');
      carePlaceholder.textContent = 'Care Instructions';
      description.appendChild(carePlaceholder);
      careFallbackAdded = true;
    }

    if (careFallbackAdded) organiseProductDescription();
  };

  initialiseFavouriteButtons();
  organiseProductDescription();
  document.addEventListener('shopify:section:load', initialiseFavouriteButtons);
  document.addEventListener('shopify:section:load', organiseProductDescription);
  if (['/products/comfortable-gown-code-angel-01', '/products/comfortable-gown-code-angel-02', '/products/comfortable-gown-code-angel-03', '/products/comfortable-gown-code', '/products/comfortable-gown-code-niva-04-copy'].includes(window.location.pathname)) {
    const details = [...document.querySelectorAll('.product-information details')].find((item) => item.querySelector('summary')?.textContent.trim().toUpperCase() === 'DETAILS')?.querySelector('.details-content .rte');
        if (details) {
      const chart = document.createElement('section');
            
      chart.className = 'gown-size-chart';
      chart.setAttribute('aria-label', 'Gown size chart');
      chart.innerHTML = `<div style="overflow:hidden;border:1px solid #d9c9c3;border-radius:10px;background:#fbf7f3;color:#52242e"><div style="padding:13px;background:#52242e;color:#fff;text-align:center"><strong style="display:block">Gown Size Chart</strong><small style="display:block;margin-top:2px;font-size:11px">MEASUREMENTS IN INCHES</small></div><table style="width:100%;border-collapse:collapse;text-align:center"><thead><tr><th style="padding:11px;border-bottom:1px solid #e6dcd7">SIZE</th><th style="padding:11px;border-bottom:1px solid #e6dcd7">BODY</th><th style="padding:11px;border-bottom:1px solid #e6dcd7">LENGTH</th></tr></thead><tbody><tr><th style="padding:11px;border-bottom:1px solid #e6dcd7">42</th><td style="padding:11px;border-bottom:1px solid #e6dcd7">42</td><td style="padding:11px;border-bottom:1px solid #e6dcd7">52</td></tr><tr><th style="padding:11px;border-bottom:1px solid #e6dcd7">44</th><td style="padding:11px;border-bottom:1px solid #e6dcd7">44</td><td style="padding:11px;border-bottom:1px solid #e6dcd7">54</td></tr><tr><th style="padding:11px">46</th><td style="padding:11px">46</td><td style="padding:11px">56</td></tr></tbody></table><small style="display:block;padding:11px;border-top:1px solid #e6dcd7;color:#655d59;text-align:center">Measurements may vary slightly by 1–2 inches.</small></div>`;
      const descriptionList = details.querySelector('ul, ol');
      (descriptionList || details.firstElementChild).after(chart);
    }
  }
  } catch(e) { console.error(e); }
})();

})();
